import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-64da83d7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "background" }
const _hoisted_2 = { class: "contain" }
const _hoisted_3 = { class: "back-arrow" }
const _hoisted_4 = { class: "cityChartTitle" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "查看项目相关机构", -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = { class: "programTitle" }
const _hoisted_8 = { class: "chartNum" }
const _hoisted_9 = { class: "chartList" }

import "@/font/css/font.css";
import { useRouter, useRoute } from 'vue-router'
import chart from "./chart.vue";
import { ref, onMounted } from 'vue'
import javaapi from "@/service/javaapi";
import { ElMessage } from "element-plus";


export default /*#__PURE__*/_defineComponent({
  __name: 'chartDetail',
  setup(__props) {

const clickButton = async () => {
  var selector = {
    ProjectId: parseInt(route.query.projectId + '')
  }
  let projectList = await javaapi.list({ entity: "project", interface: "getAllProjectsByProjectId" }, selector);
  if (projectList.project == 0) {
    projectList = await javaapi.list({ entity: "project", interface: "getAllProjectsByParentProjectId" }, selector);
    if (projectList.project == 0) {
      ElMessage.info("暂无相关机构")
      return;
    }
  }
  router.push({
    name: 'ParticipatingInstitutions',
    query: {
      organizationId: localStorage.getItem("organization_id"),
      projectId: checkup_project_id.value
    }
  });


}

const router = useRouter()

const back = () => {
  router.go(-1);

}
const isHaveprojectList = ref(true)
const checkup_project_id = ref()
const route = useRoute()
const subjectLineNum = ref(4)
onMounted(() => {
  init();
})
const subjectInfos = ref([{
  "checkup_subject_id": 0,
  "score": 0.0,
  "standard_score": 0.0,
  "checkup_subject_name": "",
  "completed_num": 0,
  "incomplete_num": 0,
  "completed_percentage": 0
},])
const organization_name = ref('')
const projectName = ref('')
const isFromProject = ref(false)
const init = async () => {
  if (route.query.isFromProject == '1') {
    isFromProject.value = true
  }
  checkup_project_id.value = parseInt(route.query.projectId + '')
  organization_name.value = route.query.organizationName + '';
  projectName.value = route.query.projectName + '';

  const query = {
    jsonText: { "organization_id": localStorage.getItem('organization_id'), "checkup_project_id": checkup_project_id.value },
    token: localStorage.getItem('token'),
    user_id: localStorage.getItem('user_id'),
  }
  const result = await javaapi.postQuery(query, '/subject/getSubjectInfo')
  // console.log('result', result)
  // console.log('result', query)
  if (result.status == 1) {
    subjectInfos.value = [...result.data]
    //console.log(subjectInfos.value)
  }
  var selector = {
    ProjectId: parseInt(route.query.projectId + '')
  }
  let projectList = await javaapi.list({ entity: "project", interface: "getAllProjectsByProjectId" }, selector);
  if (projectList.project == 0) {
    isHaveprojectList.value = false
  }
}


return (_ctx: any,_cache: any) => {
  const _component_Back = _resolveComponent("Back")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_el_icon, {
          onClick: back,
          style: {"color":"white","font-size":"1.8vw","cursor":"pointer"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_Back)
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_4, _toDisplayString(organization_name.value), 1),
      _createElementVNode("div", {
        class: "institutionButton",
        onClick: clickButton
      }, _hoisted_6),
      _createElementVNode("span", _hoisted_7, _toDisplayString(projectName.value), 1),
      _createElementVNode("span", _hoisted_8, "表的总数：" + _toDisplayString(subjectInfos.value.length), 1),
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_el_scrollbar, { "max-height": "40vh" }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Math.ceil(subjectInfos.value.length / subjectLineNum.value), (i) => {
              return (_openBlock(), _createBlock(_component_el_row, {
                gutter: 20,
                style: {"margin-bottom":"10vh","position":"relative","left":"0%"}
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(subjectLineNum.value, (j) => {
                    return (_openBlock(), _createBlock(_component_el_col, {
                      span: 24 / subjectLineNum.value
                    }, {
                      default: _withCtx(() => [
                        (((i - 1) * subjectLineNum.value + j) <= subjectInfos.value.length)
                          ? (_openBlock(), _createBlock(chart, {
                              key: 0,
                              class: "chart",
                              chartname: subjectInfos.value[(i - 1) * subjectLineNum.value + j - 1].checkup_subject_name,
                              checkup_subject_id: subjectInfos.value[(i - 1) * subjectLineNum.value + j - 1].checkup_subject_id,
                              score: subjectInfos.value[(i - 1) * subjectLineNum.value + j - 1].score,
                              standard_score: subjectInfos.value[(i - 1) * subjectLineNum.value + j - 1].standard_score,
                              completed_percentage: subjectInfos.value[(i - 1) * subjectLineNum.value + j - 1].completed_percentage,
                              "organization-name": organization_name.value
                            }, null, 8, ["chartname", "checkup_subject_id", "score", "standard_score", "completed_percentage", "organization-name"]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 2
                    }, 1032, ["span"]))
                  }), 256))
                ]),
                _: 2
              }, 1024))
            }), 256))
          ]),
          _: 1
        })
      ])
    ])
  ]))
}
}

})